<script setup lang="ts">
	import moment from 'moment'
	import { ref } from 'vue'

	import type { HotelSearchContext } from '../interfaces/hotelSearchSettings'
	import type { HotelsSearchRequest } from '../interfaces/hotelsSearchRequest'

	defineProps<{
		form: HotelsSearchRequest
		searchContext?: HotelSearchContext | null
	}>()
	const openInformation = ref(true)
	const onEscape = (event: KeyboardEvent) => {
		if (!openInformation.value) return
		event.stopPropagation()
		openInformation.value = false
	}
</script>

<template>
	<button
		type="button"
		class="max-w-full rounded-md bg-white text-left shadow-md"
		:aria-expanded="openInformation"
		aria-label="Información de la búsqueda en el mapa"
		@click="openInformation = !openInformation"
		@keydown.esc="onEscape"
	>
		<div
			class="min-w-0 cursor-pointer"
			:class="openInformation ? 'p-3' : 'p-2'"
		>
			<div
				v-if="openInformation"
				v-motion
				:initial="{ opacity: 0 }"
				:enter="{ opacity: 1, transition: { duration: 300 } }"
				class="flex min-w-0 flex-col gap-1"
			>
				<p class="text-sm font-medium md:text-lg">
					Hoteles alrededor de:
					<span class="break-words font-normal">{{ form.cityName }}</span>
				</p>
				<div class="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs">
					<span>
						{{ moment(form.Start, 'YYYY-MM-DD').format('DD/MM/YYYY') }} –
						{{ moment(form.End, 'YYYY-MM-DD').format('DD/MM/YYYY') }}
					</span>
					<span>
						{{ form.Quantity }}
						{{ form.Quantity > 1 ? 'habitaciones' : 'habitación' }}
					</span>
				</div>
				<p
					v-if="searchContext?.radiusKm"
					class="text-xs text-gray-600"
				>
					Radio de búsqueda: {{ searchContext.radiusKm }} km ·
					{{
						searchContext.radiusSource === 'branch' ? 'Sede'
						: searchContext.radiusSource === 'custom' ? 'Personalizado'
						: searchContext.radiusSource === 'company' ? 'Empresa'
						: 'Agencia'
					}}
				</p>
			</div>
			<span
				v-else
				class="material-symbols-outlined"
				aria-hidden="true"
				>info</span
			>
		</div>
	</button>
</template>
